import styled from "@emotion/styled";
const Tooltip = {
    TooltipWrapper: styled.div `
    position: relative;
  `,
    TooltipTip: styled.div `
    position: absolute;
    border-radius: 4px;
    left: 50%;
    top: calc(30px * -1);
    transform: translateX(-50%);
    padding: 6px;
    color: white;
    background: black;
    font-size: 14px;
    font-family: sans-serif;
    line-height: 1;
    z-index: 100;
    min-width: 100px;
    white-space: nowrap;

    &::before {
      content: " ";
      left: 50%;
      border: solid transparent;
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-width: 6px;
      margin-left: calc(6px * -1);
      top: 100%;
      border-top-color: black;
    }
  `,
};
export default Tooltip;
//# sourceMappingURL=Tooltip.styled.js.map